<template>
  <div class="footer">
    <!-- <div class="pre"></div> -->
    <div class="content">
      <div class="start">
        <el-image class="logo" :src="$common.getResourceUrl('logo2.png')" />
        <div class="menus">
          <div
            v-for="(lie, lie_index) in menus"
            :key="lie_index"
            class="column"
          >
            <!-- <div class="h"></div> -->
            <el-button
              class="h"
              :style="{
                cursor: lie.url ? 'pointer' : 'default',
              }"
              type="text"
              >{{ lie.name }}</el-button
            >
            <div class="buttons">
              <el-button
                v-for="(i, i_index) in lie.children"
                :key="i_index"
                class="c"
                :style="{
                  cursor: i.url ? 'pointer' : 'default',
                }"
                type="text"
                >{{ i.name }}</el-button
              >
            </div>
          </div>
        </div>
        <div class="codes">
          <div v-for="i in 3" :key="i" class="item">
            <div class="img-box">
              <el-image :src="$common.getResourceUrl('gongzhonghao.jpg')" />
            </div>

            <div class="name">微信公众号</div>
          </div>
        </div>
      </div>
      <div class="copyright">
        <div class="copytext">
          <span
            ><a href="https://beian.miit.gov.cn/" target="_blank"
              ><span>{{ $domain.beian }}</span>
            </a></span
          >
          <span v-if="$domain.code == 'XiaoBai'"
            >增值电信业务经营许可证：
            <a
              href="https://tsm.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=%25E9%25B2%2581B2-20220133&type=xuke"
              target="_blank"
              >鲁B2-20200644</a
            ></span
          >
          <span>{{ $domain.company }}/或其关联公司及特许人版权所有</span>
          <span>联系地址：{{ $domain.address }}5</span>
        </div>
        <!-- <div class="shops">
          <span class="shop-item"
            ><img
              :src="require('@/assets/img/icon-jingdong.png')"
            />京东旗舰店</span
          >
          <span class="shop-item"
            ><img
              :src="require('@/assets/img/icon-taobao.png')"
            />淘宝旗舰店</span
          >
          <span class="shop-item"
            ><img
              :src="require('@/assets/img/icon-douyin.png')"
            />抖音旗舰店</span
          >
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageFooter',
  components: {},
  props: {},
  data() {
    return {
      menus: [
        {
          name: '关于我们',
          url: '',
          method: '',
          children: [
            {
              name: '平台介绍',
              url: '',
              method: '',
              children: [],
            },
            {
              name: '联系我们',
              url: '',
              method: '',
              children: [],
            },
            {
              name: '学员故事',
              url: '',
              method: '',
              children: [],
            },
          ],
        },
        {
          name: '课程产品',
          url: '',
          method: '',
          children: [
            {
              name: '插画学院',
              url: '',
              method: '',
              children: [],
            },
            {
              name: '原画学院',
              url: '',
              method: '',
              children: [],
            },
            {
              name: '设计学院',
              url: '',
              method: '',
              children: [],
            },
          ],
        },
        {
          name: '最新活动',
          url: '',
          method: '',
          children: [
            {
              name: '小白赛事',
              url: '',
              method: '',
              children: [],
            },
            {
              name: '接单大厅',
              url: '',
              method: '',
              children: [],
            },
          ],
        },
        {
          name: '更多信息',
          url: '',
          method: '',
          children: [
            {
              name: '意见反馈',
              url: '',
              method: '',
              children: [],
            },
            {
              name: '求贤招聘',
              url: '',
              method: '',
              children: [],
            },
            {
              name: '商务合作',
              url: '',
              method: '',
              children: [],
            },
          ],
        },
      ],
    }
  },
  created() {},
  mounted() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  background: #2b303b;
  min-width: 1240px;
  overflow: hidden;

  .pre {
    height: 83px;
    background-color: #338bf6;
    background-image: url('../../assets/img/footpre.jpg');
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center;
  }

  .content {
    width: 1240px;
    padding: 0 20px;
    margin: 0 auto;
  }
}

.start {
  height: 260px;
  // display: flex;
  display: none;
  justify-content: space-between;
  align-items: center;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    width: 100vw;
    min-width: 1240px;
    height: 1px;
    background: #eeeeee;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .logo {
    width: 166px;
    height: auto;
    flex-shrink: 0;
  }
  .menus {
    display: flex;
    margin: 0 66px 0 50px;
    .column {
      width: 100px;
      text-align: center;
      font-size: 15px;
      line-height: 21px;
      overflow: hidden;
      margin-right: 36px;
      &:last-child {
        margin-right: 0;
      }
      .h {
        font-size: 15px;
        font-weight: 500;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #211815;
        padding: 0;
      }
      .buttons {
        width: 100%;
        .c {
          display: block;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #636363;
          margin: 25px auto 0 auto;
          padding: 0;
          font-size: 15px;
        }
      }
    }
  }
  .codes {
    display: flex;
    justify-content: space-between;
    .item {
      display: flex;
      align-items: center;
      justify-items: center;
      flex-direction: column;
      margin-left: 50px;
      &:first-child {
        margin-left: 0;
      }
      .img-box {
        padding: 8px;
        border-radius: 10px;
        border: 1px solid #e0e0e0;
        margin-bottom: 16px;
        width: 90px;
        height: 90px;
        .el-image {
          display: block;
          width: 100%;
          height: 100%;
        }
      }

      .name {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #211815;
        line-height: 21px;
      }
    }
  }
}

.copyright {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // color: #828282;
  color: #cbcbcb;
  line-height: 26px;
  padding-top: 25px;
  padding-bottom: 25px;
  text-align: center;

  a {
    color: #cbcbcb;
  }

  .copytext {
    // .icon {
    //   width: 16px;
    //   height: 16px;
    //   vertical-align: middle;
    //   margin-top: -3px;
    //   margin-right: 4px;
    // }
    margin-left: -10px;
    & > span {
      margin-left: 10px;
    }
  }
  .shops {
    margin-left: -15px;
    .shop-item {
      margin-left: 15px;
      img {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 4px;
      }
    }
  }
}
</style>
